import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { routes } from '@app/consts/routes';
import { features } from '@app/consts';
import { TranslateService } from '@ngx-translate/core';
import { FeatureService } from '@app/core/services/feature.service';
import { modules } from '@app/consts/modules';
import { ModuleConfigurationService } from '@app/core/services/module-configuration/module-configuration.service';

@Component({
  selector: 'app-buy-sell-menu',
  templateUrl: './buy-sell-menu.component.html',
  styleUrls: ['./buy-sell-menu.component.scss']
})
export class BuySellMenuComponent implements OnInit {
  public routes: typeof routes = routes;
  navList = [
    {
      text: 'BuySellPlans',
      link: `${routes.TIME_OFF}${routes.BUY_SELL}${routes.BUY_SELL_PLANS}`,
      icon: 'sell',
      featureCode: features.BUY_SELL_ADMIN
    },
    {
      text: 'BuySellApprovals',
      link: `${routes.TIME_OFF}${routes.BUY_SELL}${routes.APPROVALS}`,
      icon: 'flaky',
      featureCode: features.BUY_SELL
    },
  ];

  constructor(
    private translate: TranslateService,
    public router: Router,
    private featureService: FeatureService,
    private moduleConfigurationService: ModuleConfigurationService,
  ) {
  }

  ngOnInit(): void {
    this.navigateToFirstAllowedSection();
  }

  navigateToFirstAllowedSection() {
    let urlToNavigateTo = '';

    if (this.router.url === `${routes.TIME_OFF}${routes.BUY_SELL}`) {
      this.navList.every(element => {
        let hasAccess = this.featureService.hasFeatureAccess(element.featureCode)

        if (hasAccess) {
          urlToNavigateTo = element.link;
          return false;
        }

        return true;
      });
    }

    if (urlToNavigateTo !== '') {
      this.router.navigate([urlToNavigateTo]);
    }
  }
}
